/**
 * Приводит дату к ISO 8601 в UTC (YYYY-MM-DDThh:mm:ss+00:00).
 * Важно: без локальной таймзоны рантайма — иначе SSR и браузер дают разные строки и ломают гидрацию React.
 */
export const toISOStringWithTimezone = (date: Date) => {
  return date.toISOString().replace(/\.\d{3}Z$/, '+00:00');
};
